import {
  MultiSelectorContentClose,
  MultiSelectorSeparator,
  MultiSelectorBadgeItem,
  MultiSelectorTrigger,
  MultiSelectorContent,
  MultiSelectorInput,
  MultiSelectorList,
  MultiSelector,
  BadgeColor,
  Button,
} from '@ui/components';
import { PropsWithChildren, useState } from 'react';

export interface BadgeMultiselectProps extends PropsWithChildren {
  options: {
    variant?: BadgeColor | string;
    disabled?: boolean;
    label: string;
    value: string;
  }[];
  searchPlaceholder?: string;
  buttonLabel: string;
  isLoading?: boolean;
  disabled?: boolean;
  value?: string[];
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  onSave: (value: string[]) => void;
}

export const BadgeMultiselect = ({
  searchPlaceholder,
  buttonLabel,
  value = [],
  setIsOpen,
  isLoading,
  disabled,
  children,
  options,
  isOpen,
  onSave,
}: BadgeMultiselectProps) => {
  const [selected, setSelected] = useState<string[]>(value);

  return (
    <MultiSelector
      onValuesChange={setSelected}
      setIsOpen={setIsOpen}
      disabled={disabled}
      className="w-auto"
      values={selected}
      isOpen={isOpen}
    >
      <MultiSelectorTrigger asChild>{children}</MultiSelectorTrigger>
      <MultiSelectorContent className="w-72">
        <MultiSelectorInput placeholder={searchPlaceholder} />
        <MultiSelectorSeparator />
        <MultiSelectorList variant="wrapped">
          {options.map((option) => (
            <MultiSelectorBadgeItem
              variant={option.variant as BadgeColor}
              disabled={option.disabled}
              label={option.label}
              value={option.value}
              key={option.value}
            />
          ))}
        </MultiSelectorList>
        <MultiSelectorSeparator />

        <div className="p-2">
          {!!setIsOpen ? (
            <Button
              onClick={() => onSave(selected)}
              isLoading={isLoading}
              disabled={isLoading}
              variant="primary"
              type="button"
              wide
            >
              {buttonLabel}
            </Button>
          ) : (
            <MultiSelectorContentClose
              onClick={() => onSave(selected)}
              variant="primary"
              type="button"
              wide
            >
              {buttonLabel}
            </MultiSelectorContentClose>
          )}
        </div>
      </MultiSelectorContent>
    </MultiSelector>
  );
};
